import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IProductCategory } from "../products";

export default class CategoryStore {
  categories: Array<IProductCategory> = [];
  editCategory: IProductCategory | null = null;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchCategories = () => {
    const url = ApiConfig.REST_URIS.category.fech;
    Api.get(url, (res: ApiResponse<IProductCategory[]>) => {
      if (res?.isSuccess && res.data) {
        this.categories = _.sortBy(res.data, "name");
      }
    });
  };

  saveCategory = (cat: IProductCategory, callback: Function) => {
    if (cat.id) {
      Api.put(
        ApiConfig.REST_URIS.category.update(cat.id),
        cat,
        (res: ApiResponse<number>) => {
          callback && callback(res);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.category.create,
        cat,
        (res: ApiResponse<number>) => {
          callback && callback(res);
        }
      );
    }
  };

  deleteCategory = (id: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.category.delete(id);

    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  setEditCategory = (cat: IProductCategory | null) => {
    this.editCategory = cat;
  };
}
